module.exports = __webpack_public_path__ + "static/img/10.75f6c1a3.jpg";